<template>
    <div>
        <h3 v-if="query">{{ $t('noResults', { QUERY: query }) }}</h3>
        <h3 v-else>{{ $t('noResultsFilterOnly') }}</h3>
        <h4 class="mt-4">{{ $t('noResultsHints.suggestions') }}</h4>
        <ul>
            <li>{{ $t('noResultsHints.checkSpelling') }}</li>
            <li>{{ $t('noResultsHints.tryDifferentKeywords') }}</li>
            <li>{{ $t('noResultsHints.tryGenericKeywords') }}</li>
        </ul>
    </div>
</template>

<script>
import { Vue } from 'vue-property-decorator';

export default Vue.extend({
    name: 'NoResults',
    props: {
        query: {
            type: String,
            required: true,
        },
    },
});
</script>

<style scoped></style>
